import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Form, Input, message } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { postRequest } from '../../../../../core/apiRequests';
import { SettingsContent } from '../../components/SettingsContent';

const ChangePassword = ({ auth }) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCancel = useCallback(() => {
    form.resetFields();
    history.push('/EditProfile');
  }, [form, history]);

  const handleSave = useCallback(async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();

      await postRequest({
        params: ['associates', 'updatePassword'],
        data: {
          oldPassword: values.oldPassword,
          password: values.newPassword,
        },
      });

      form.resetFields();
      message.success('Password changed successfully');
      history.push('/EditProfile');
    } catch (error) {
      console.error('Password change failed:', error);
      if (error.status === 400) {
        message.error(error.response?.data?.data?.message || 'Current password is incorrect');
      } else if (error.errorFields) {
        message.error('Please check all required fields');
      } else {
        message.error('Failed to change password. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  }, [form, history]);

  return (
    <StandardLayoutV2
      title="Change Password"
      breadcrumb={[{ title: 'Edit Profile', path: '/EditProfile' }, { title: 'Change Password' }]}
      classProps="flex-col-left"
      maxWidth="720px"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent', paddingRight: '32px', width: '100%' }}
      actions={
        <div className="flex-row gap-16 items-center">
          <Button onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={loading} loading={loading} type="primary">
            Save
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" className="w-100-P" disabled={loading}>
        <div style={{ maxWidth: '400px' }}>
          <Form.Item
            label="Current Password"
            name="oldPassword"
            rules={[{ required: true, message: 'Please enter your current password' }]}
          >
            <Input.Password placeholder="Enter current password" />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: 'Please enter your new password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('oldPassword') !== value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('New password must be different from current password'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmNewPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm your new password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </div>
      </Form>
    </StandardLayoutV2>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(ChangePassword);
